const DELIVERY_GRACE_MS = 100;
const HIDDEN_DELIVERY_TIMEOUT_MS = 1000;

/**
 * Wait for the browser to finish the frame running when measurement stopped,
 * then allow its Long Animation Frame (LoAF) timing data to arrive.
 * While the tab is visible, keep waiting even if that frame takes a long time.
 * If the tab is hidden and animation callbacks stop, report available data as incomplete.
 */
export function waitForPainWindowDelivery(
  finish: (deliveryComplete: boolean) => void
): () => void {
  let finished = false;
  let graceTimer: ReturnType<typeof setTimeout> | undefined;
  let hiddenTimer: ReturnType<typeof setTimeout>;
  const frameRequest = requestAnimationFrame(() => {
    graceTimer = setTimeout(() => complete(true), DELIVERY_GRACE_MS);
  });

  function cancel() {
    finished = true;
    cancelAnimationFrame(frameRequest);
    clearTimeout(graceTimer);
    clearTimeout(hiddenTimer);
  }

  function complete(deliveryComplete: boolean) {
    if (finished) {
      return;
    }
    cancel();
    finish(deliveryComplete);
  }

  function checkHidden() {
    if (document.visibilityState !== 'visible') {
      complete(false);
      return;
    }
    hiddenTimer = setTimeout(checkHidden, HIDDEN_DELIVERY_TIMEOUT_MS);
  }
  hiddenTimer = setTimeout(checkHidden, HIDDEN_DELIVERY_TIMEOUT_MS);
  return cancel;
}
